import { defineComponent as v, ref as B, computed as g, createElementBlock as i, openBlock as t, normalizeStyle as S, normalizeClass as I, createElementVNode as p, renderSlot as l, createCommentVNode as s, createVNode as c, withCtx as f, createBlock as n } from "vue";
import { _ as d } from "./Button.ce.vue_vue_type_script_setup_true_lang-3QjuPmOY.js";
import u from "./SvgRender.js";
import { _ } from "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
import A from "./OverflowTooltip.js";
import { b as O } from "./baseMixins-HJffeBsS.js";
import { _ as $ } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const j = { class: "arbo-chip__wrapper" }, w = { class: "arbo-chip__main" }, F = { class: "arbo-chip__base-wrapper" }, z = {
  key: 0,
  class: "arbo-chip__prefix"
}, N = {
  key: 0,
  class: "arbo-chip__suffix"
}, V = {
  key: 0,
  class: "arbo-chip__append"
}, D = /* @__PURE__ */ v({
  __name: "Chip",
  props: {
    ...O,
    prefixContent: {
      type: Object,
      default: () => ({})
    },
    suffixContent: {
      type: Object,
      default: () => ({})
    },
    appendContent: {
      required: !1,
      type: Object,
      default: () => ({})
    },
    componentStyles: {
      type: Object,
      default: () => ({})
    },
    disableHover: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["prefixClicked", "suffixClicked", "appendClicked"],
  setup(b, { emit: C }) {
    B(!1);
    const e = b, r = C, x = {
      "--bg-main-color": "#A3D4F5",
      "--prefix-color": "#232323",
      "--suffix-color": "#232323",
      "--prefix-hover-color": "#f7941d",
      "--suffix-hover-color": "#232323",
      "--label-color": "#232323",
      "--append-color": "#3C9BFA",
      "--hover-bg-main-color": "#A3D4F5",
      "--hover-border-main-color": "#3C9BFA"
    }, h = g(() => ({
      ...e.sharedStyles,
      ...x,
      ...e.componentStyles
    })), a = (o) => !!/^(?:https?|data:image\/(?:png|jpe?g|gif|webp|svg))/i.test(o), m = () => {
      r("prefixClicked");
    }, y = () => {
      r("suffixClicked");
    }, k = () => {
      r("appendClicked");
    };
    return (o, E) => (t(), i("div", {
      class: I(["arbo-chip", [e.size, { "no-hover": e.disableHover }, { disable: e.disable }]]),
      style: S(h.value)
    }, [
      p("div", j, [
        p("div", w, [
          p("div", F, [
            l(o.$slots, "prefix", {
              prefixContent: e.prefixContent
            }, () => [
              e.prefixContent && e.prefixContent.content ? (t(), i("div", z, [
                c(_, {
                  class: "arbo-chip__tooltip",
                  content: !e.disable && e.prefixContent.tooltip ? e.prefixContent.tooltip : "",
                  delay: [300, 0]
                }, {
                  default: f(() => [
                    a(e.prefixContent.content) ? (t(), n(u, {
                      key: 0,
                      class: "arbo-chip__prefix__thumbnail",
                      url: e.prefixContent.content
                    }, null, 8, ["url"])) : (t(), n(d, {
                      key: 1,
                      class: "arbo-chip__prefix__btn",
                      type: "tertiary",
                      onClick: m,
                      suffixIcon: e.prefixContent.content,
                      label: "",
                      disable: e.disable
                    }, null, 8, ["suffixIcon", "disable"]))
                  ]),
                  _: 1
                }, 8, ["content"])
              ])) : s("", !0)
            ], !0),
            l(o.$slots, "default", {}, () => [
              e.label ? (t(), n(A, {
                key: 0,
                class: "arbo-chip__label",
                title: e.label
              }, null, 8, ["title"])) : s("", !0)
            ], !0)
          ]),
          l(o.$slots, "suffix", {
            suffixContent: e.suffixContent
          }, () => [
            e.suffixContent && e.suffixContent.content ? (t(), i("div", N, [
              c(_, {
                class: "arbo-chip__tooltip",
                content: !e.disable && e.suffixContent.tooltip ? e.suffixContent.tooltip : "",
                delay: [300, 0]
              }, {
                default: f(() => [
                  a(e.suffixContent.content) ? (t(), n(u, {
                    key: 0,
                    class: "arbo-chip__prefix__thumbnail",
                    url: e.suffixContent.content
                  }, null, 8, ["url"])) : (t(), n(d, {
                    key: 1,
                    class: "arbo-chip__suffix__btn",
                    type: "tertiary",
                    onClick: y,
                    suffixIcon: e.suffixContent.content,
                    label: "",
                    disable: e.disable
                  }, null, 8, ["suffixIcon", "disable"]))
                ]),
                _: 1
              }, 8, ["content"])
            ])) : s("", !0)
          ], !0)
        ])
      ]),
      l(o.$slots, "append", {
        appendContent: e.appendContent
      }, () => [
        e.appendContent && e.appendContent.content ? (t(), i("div", V, [
          c(_, {
            class: "arbo-chip__tooltip",
            content: !e.disable && e.appendContent.tooltip ? e.appendContent.tooltip : "",
            delay: [300, 0]
          }, {
            default: f(() => [
              a(e.appendContent.content) ? (t(), n(u, {
                key: 0,
                class: "arbo-chip__prefix__thumbnail",
                url: e.appendContent.content
              }, null, 8, ["url"])) : (t(), n(d, {
                key: 1,
                class: "arbo-chip__prefix__btn",
                type: "tertiary",
                onClick: k,
                suffixIcon: e.appendContent.content,
                label: "",
                disable: e.disable
              }, null, 8, ["suffixIcon", "disable"]))
            ]),
            _: 1
          }, 8, ["content"])
        ])) : s("", !0)
      ], !0)
    ], 6));
  }
}), G = /* @__PURE__ */ $(D, [["__scopeId", "data-v-a7758c4b"]]);
export {
  G as default
};
